import classNames from 'classnames';
import React, { useEffect, useState, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { DFPSlotsProvider } from 'react-dfp';
import Head from 'next/head';
import { withRouter, NextRouter } from 'next/router';
import { DFPConfig } from '../common/helpers/ads/dfp';
import { parseScreenType } from '../common/helpers/utility/screenHelper';
import { emitter, WINDOW_RESIZE } from '../common/helpers/ui/EventHelper';
import { SCREEN_TYPE } from '../common/helpers/constants';
import config from '../common/config';
import Header from '../components/header/Header';

import favicon from '../common/assets/icons/favicon.ico';
import { GlobalStyle, MainWrapper } from './main.style';
import { refreshAds } from '../common/helpers/ads/AdsHelper';
import { WholeState } from '../store/common/type';

const metaContent: string = `${config.metaRobotContent}`;

interface MainComponentProps {
  children: ReactNode;
  source?: string;
  shouldCollapseEmptyAdSlots?: boolean;
  router: NextRouter;
  adUnit?: string;
}

const MainComponent: React.FC<MainComponentProps> = ({
  children,
  source = '',
  shouldCollapseEmptyAdSlots = false,
}) => {
  const [screenType, setScreenType] = useState<keyof typeof SCREEN_TYPE>(
    SCREEN_TYPE.desktop,
  );
  const modalVisible = useSelector(
    (state: WholeState) => state.common?.modalVisible ?? false,
  );

  useEffect(() => {
    const handleWindowResize = () => {
      // Refresh ads when window is resized
      const newScreenType = parseScreenType();
      if (newScreenType !== screenType) {
        setScreenType(newScreenType);
        refreshAds();
      }
    };

    if (config.isBrowser) {
      emitter.on(WINDOW_RESIZE, handleWindowResize);
    }

    setScreenType(parseScreenType());

    return () => {
      if (config.isBrowser) {
        emitter.off(WINDOW_RESIZE, handleWindowResize);
      }
    };
  }, [screenType]);

  return (
    <DFPSlotsProvider
      dfpNetworkId={DFPConfig.dfpNetworkId}
      collapseEmptyDivs={shouldCollapseEmptyAdSlots}
      adUnit=""
    >
      <div className={classNames({ 'no-scroll': modalVisible })}>
        <Head>
          <title key="title">ThinkOfLiving.com</title>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, shrink-to-fit=no"
          />
          <meta name="theme-color" content="#000000" />
          <meta name="robots" content={metaContent} />
          <link rel="shortcut icon" type="image/x-icon" href={favicon} />
        </Head>

        <MainWrapper data-testid="main-wrapper">
          <GlobalStyle />
          <Header source={source} />
          {children}
        </MainWrapper>
      </div>
    </DFPSlotsProvider>
  );
};

export default withRouter(MainComponent);
